import { Role, UserWithMeta } from 'src/common-services'
import { currentUser } from 'src/atoms/user'
import { atom, selector, useRecoilValue } from 'recoil'

export const STORE_EMAIL_KEY = 'email'

// HACK(bmc): we need to use a hook here instead of a global type function
let userIsAdmin = false
export const isAdmin = (): boolean => {
  return userIsAdmin
}

export const getSavedEmail = (): string | undefined => {
  return localStorage.getItem(STORE_EMAIL_KEY) || undefined
}

export const injectedAuthData = atom<UserWithMeta | undefined>({
  key: 'server-injected-auth-data',
  default: undefined,
})

export const authData = selector<UserWithMeta | undefined>({
  key: 'auth-data',
  get: ({ get }) => {
    return get(injectedAuthData) || get(currentUser)
  },
})

/**
 * Returns auth data if user has valid tokens, otherwise undefined
 */
export const useAuthData = (): UserWithMeta | undefined => {
  const user = useRecoilValue(authData)
  if (!user) {
    return undefined
  }
  // HACK(bmc): global side effects in a hook are bad
  // but this is better than the previous incarnation which was
  // a very bad and buggy auth system...TODO: cleanup usage of this hook and isAdmin()
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORE_EMAIL_KEY, user.email)
  }
  userIsAdmin = user.role === Role.admin
  return user
}
